import { render, staticRenderFns } from "./cv-form-group.vue?vue&type=template&id=224767a6&"
import script from "./cv-form-group.vue?vue&type=script&lang=js&"
export * from "./cv-form-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports